// En productos vendidos por packs (opción "Cantidad"), +/− en el carrito cambia de pack en vez de multiplicar la unidad suelta.
(function () {
  var busy = false;

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var doc = new DOMParser().parseFromString(s['cart-drawer'] || '', 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var cur = document.querySelector('#CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var overlay = document.querySelector('#CartDrawer-Overlay');
        var drawer = document.querySelector('cart-drawer');
        if (overlay && drawer && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
        if (s['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          var bc = document.getElementById('cart-icon-bubble');
          if (b && bc) bc.innerHTML = b.innerHTML;
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('quantity-input[data-pack-line] .quantity__button');
    if (!btn) return;
    var qi = btn.closest('quantity-input');
    var target = btn.name === 'plus' ? qi.dataset.packNext : qi.dataset.packPrev;
    if (!target) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    qi.style.opacity = '0.5';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: qi.dataset.packLine, quantity: 0 })
    })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(target), quantity: 1 }] })
        });
      })
      .then(refreshDrawer)
      .catch(function () { window.location.reload(); })
      .then(function () { busy = false; });
  }, true);
})();
